/**
 * Checks if the stress is in the filtered stresses list and updates the values accordingly.
 * @param {boolean} actionTypeInputIsInViewMode - Indicates if the action type input is in view mode.
 * @param {object} values - The current values object.
 * @param {function} setValues - The function to update the values object.
 * @param {array} filteredStresses - The filtered stresses list.
 * @param {string} stressType - The stress type.
 */
const checkIfStressInFilteredStresses = (
  actionTypeInputIsInViewMode,
  values,
  setValues,
  filteredStresses,
) => {
  if (!actionTypeInputIsInViewMode) {
    const stressId = values?.caused?.stressId;

    if (
      stressId &&
      !filteredStresses.map(({ value }) => value).includes(stressId)
    ) {
      setValues((prev) => ({
        ...prev,
        caused: { ...prev?.caused, stressId: "", stressName: "" },
      }));
    }
  }
};

export default checkIfStressInFilteredStresses;
